<template lang="pug">
.the-navigation-drawer
  k-icon-hamburger(
    :value="opened"
    @input="toggleOpen"
  )
  client-only
    v-navigation-drawer(
      fixed
      right
      :style="styles"
      v-model="opened"
    ).brand-dark-blue-70
      k-card-text.pa-12
        template(v-if="!userIsAuthenticated")
          k-button(block :to="pages.login").my-9 {{ $t('app.pages.login.title') }}
          k-button-outline(color="white" block :to="pages.joinNow").mb-10 {{ $t('app.pages.joinNow.title') }}
        .small-caps.brand-pink--text.pb-6 Find
        nuxt-link(
          v-for="(item, key) in findLinks"
          :key="key"
          :to="item"
          @click.native="toggleClose"
          v-if="item"
        ).paragraph--large.white--text.unstyled--link
          .white--text.mb-2 {{ $t('app.pages.' + key + '.title') }}
        template(v-if="userIsAuthenticated")
          .small-caps.brand-pink--text.pb-6.pt-10 My Dashboard
          nuxt-link(
            v-for="(item, key) in dashboardLinks"
            :key="key"
            :to="item.link"
            @click.native="toggleClose(item)"
            v-if="item"
          ).paragraph--large.white--text.unstyled--link.d-block
            .d-flex.align-center.mb-3
              .white--text.pr-3 {{ item.name }}
              //- don't show chip if the sub links are open
              v-chip(v-if="item.alerts && (!item.sub || (item.sub && activeDashboardTab.name !== item.name))" color="white" text-color="brand-dark-blue-70" x-small).the-navigation-drawer__alert-chip
                span.font-weight-bold {{ item.alerts }}
            template(v-if="activeDashboardTab && activeDashboardTab.name === item.name")
              .mb-3(v-if="activeDashboardTab.sub")
                nuxt-link(:to="sub.link" v-for="sub in activeDashboardTab.sub" :key="sub.name").d-block.unstyled--link.pl-4.pb-2
                  .d-flex.align-center
                    .brand-grey-40--text.the-navigation-drawer__sub-link.pr-3 {{ sub.name }}
                    v-chip(v-if="sub.alerts" color="white" text-color="brand-dark-blue-70" x-small).the-navigation-drawer__alert-chip
                      span.font-weight-bold {{ sub.alerts }}
        .small-caps.brand-pink--text.pb-6.pt-10 Discover
        nuxt-link(
        v-for="(item, key) in discoverLinks"
        :key="key"
        :to="item"
        @click.native="toggleClose"
        v-if="item"
        ).paragraph--large.white--text.unstyled--link
          .white--text.mb-2 {{ $t('app.pages.' + key + '.title') }}
        .small-caps.brand-pink--text.pb-6.pt-10 Get in touch
        nuxt-link(
          :to="pages.getInTouch"
        ).paragraph--large.white--text.unstyled--link
          .white--text {{ $t('app.pages.getInTouch.title') }}
        k-button-outline(v-if="userIsAuthenticated" color="white" block :to="pages.signOut").mt-10.my-2 {{ $t('app.pages.signOut.title') }}
</template>

<script>
import { UsesAuthenticatedUser, UsesDashboardLinks } from '@/mixins'
import { get } from 'vuex-pathify'

export default {
  mixins: [ UsesAuthenticatedUser, UsesDashboardLinks ],
  props: {
    pages: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      opened: false,
    }
  },
  computed: {
    ...get({
      awaitingBookingSession: 'myKintell/awaitingBookingSession',
      activeDashboardTabIndex: 'myKintell/activeDashboardTabIndex'
    }),
    activeDashboardTab () {
      return this.dashboardLinks[this.activeDashboardTabIndex]
    },
    alertCount () {
      return this.authenticatedUser ?? this.authenticatedUser.stats.alerts + (this.authenticatedUser.stats.bookingActive ? 1 : 0)
    },
    styles () {
      return {
        width: '100%',
        transform: `translateX(${this.opened ? 0 : 100}%)`
      }
    },
    discoverLinks () {
      return {
        becomeAnAdvisor: this.authenticatedUser ? (this.authenticatedUserIsLearner ? this.pages.joinNow : false) : this.pages.becomeAnAdvisor,
        pricing: this.pages.pricing,
        faqs: this.pages.faqs,
        articles: this.pages.articles,
      }
    },
    findLinks () {
      return {
        search: this.pages.search,
        browseByCategory: this.pages.browseByCategory,
      }
    },
  },
  methods: {
    toggleOpen () {
      this.opened = true
    },
    toggleClose (item) {
      this.activeDashboardTab = item
      this.opened = false
    }
  },
}
</script>

<style lang="scss" scoped>
.nuxt-link-active {
  background-color: transparent !important;
}

.the-navigation-drawer {
  z-index: 8;

  &__alert-chip {
    height: 14px !important;
    padding: 0 6px !important;
    font-size: $badge-font-size !important;
  }

  &__sub-link {
    font-size: 16px;
    line-height: 24px;
  }
}

.k-icon-hamburger {
  z-index: 9;
}

.v-navigation-drawer--close {
  pointer-events: none !important;
}
</style>
